/**
 * ia-size-upsell: PDP "Available in your size" recommendations when selected variant is unavailable.
 * Fetches /collections/all with size + availability filters, injects slider and inits Swiper.
 */
var IA_SIZE_UPSELL_DEBUG = true;
function iaSizeUpsellLog() {
  if (IA_SIZE_UPSELL_DEBUG && window.console) console.log.apply(console, ['[ia-size-upsell]'].concat(Array.prototype.slice.call(arguments)));
}

class IaSizeUpsell extends HTMLElement {
  constructor() {
    super();
    this.placeholder = null;
    this.swiperInstance = null;
    this._ctaClickHandler = null;
    this._lastRenderedVariantId = null;
    this.boundUpdate = this.update.bind(this);
  }

  connectedCallback() {
    iaSizeUpsellLog('connectedCallback');
    this.placeholder = this.querySelector('#ia-size-upsell-placeholder');
    if (!this.placeholder) {
      iaSizeUpsellLog('connectedCallback: no #ia-size-upsell-placeholder, abort');
      return;
    }
    var form = this.closest('product-info') && this.closest('product-info').querySelector('form') || document.querySelector('[data-main-product] form');
    var variantInput = form && form.querySelector('input[name="id"]');
    if (!variantInput) {
      iaSizeUpsellLog('connectedCallback: no form or input[name="id"], abort');
      return;
    }
    iaSizeUpsellLog('connectedCallback: ok, calling update()');
    this.update();
    variantInput.addEventListener('change', this.boundUpdate);
  }

  disconnectedCallback() {
    var form = this.closest('product-info') && this.closest('product-info').querySelector('form') || document.querySelector('[data-main-product] form');
    var variantInput = form && form.querySelector('input[name="id"]');
    if (variantInput) variantInput.removeEventListener('change', this.boundUpdate);
    this.destroySwiper();
  }

  getVariantData() {
    var script = document.querySelector('[data-uc-variant-data_b]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  getCurrentVariantId() {
    var form = this.closest('product-info') && this.closest('product-info').querySelector('form') || document.querySelector('[data-main-product] form');
    var input = form && form.querySelector('input[name="id"]');
    return input ? String(input.value).trim() : null;
  }

  isVariantUnavailable(variant) {
    if (!variant) return true;
    return variant.shipping_status !== 'ready';
  }

  getSelectedSize() {
    var optionKey = this.dataset.sizeOptionKey;
    if (!optionKey) return null;
    var variantId = this.getCurrentVariantId();
    var variants = this.getVariantData();
    var variant = variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return null;
    return variant[optionKey] || null;
  }

  update() {
    iaSizeUpsellLog('update()');
    var variantId = this.getCurrentVariantId();
    if (variantId === this._lastRenderedVariantId) {
      iaSizeUpsellLog('update: same variantId, skip');
      return;
    }
    this._lastRenderedVariantId = variantId;
    var variants = this.getVariantData();
    var variant = variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    var unavailable = this.isVariantUnavailable(variant);
    var selectedSize = this.getSelectedSize();

    iaSizeUpsellLog('update: variantId=', variantId, 'unavailable=', unavailable, 'selectedSize=', selectedSize);

    if (!unavailable) {
      iaSizeUpsellLog('update: variant is available, hide');
      this.hidden = true;
      this.placeholder.innerHTML = '';
      this.destroySwiper();
      return;
    }

    iaSizeUpsellLog('update: variant unavailable, fetchAndRender');
    this.hidden = false;
    this.fetchAndRender(selectedSize);
  }

  buildCtaUrl() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var basePath = base.replace(/\/$/, '') + '/collections/all';
    var params = new URLSearchParams();
    params.set('filter.v.m.custom.status_new', 'Ready to Ship');
    var selectedSize = this.getSelectedSize();
    if (selectedSize) {
      params.set('filter.v.option.size', selectedSize);
    }
    var mensWomens = this.dataset.mensWomens;
    if (mensWomens) {
      params.set('filter.p.m.custom.mens_womens', mensWomens);
    }
    return basePath + '?' + params.toString();
  }

  buildCollectionUrl(selectedSize) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var basePath = base.replace(/\/$/, '') + '/collections/all';
    var params = new URLSearchParams();
    params.set('section_id', 'ia-size-upsell');
    params.set('filter.v.m.custom.status_new', 'Ready to Ship');
    if (selectedSize) {
      params.set('filter.v.option.size', selectedSize);
    }
    var productType = this.dataset.productType;
    if (productType) {
      params.set('filter.p.product_type', productType);
    }
    var mensWomens = this.dataset.mensWomens;
    if (mensWomens) {
      params.set('filter.p.m.custom.mens_womens', mensWomens);
    }
    return basePath + '?' + params.toString();
  }

  fetchAndRender(selectedSize) {
    var url = this.buildCollectionUrl(selectedSize);
    iaSizeUpsellLog('fetchAndRender: url=', url);
    if (!url) {
      iaSizeUpsellLog('fetchAndRender: no url, abort');
      return;
    }

    fetch(url)
      .then(function (res) {
        iaSizeUpsellLog('fetchAndRender: response status=', res.status, res.statusText);
        return res.text();
      })
      .then(function (html) {
        iaSizeUpsellLog('fetchAndRender: html length=', html && html.length);
        this.renderSectionHtml(html);
      }.bind(this))
      .catch(function (err) {
        iaSizeUpsellLog('fetchAndRender: catch', err);
        this.placeholder.innerHTML = '';
      }.bind(this));
  }

  renderSectionHtml(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var section = doc.querySelector('[data-ia-size-upsell-section-id]');
    if (!section) {
      iaSizeUpsellLog('renderSectionHtml: no [data-ia-size-upsell-section-id] in response');
      this.placeholder.innerHTML = '';
      return;
    }

    this.placeholder.innerHTML = section.innerHTML;

    // Remove the current product if it appears in results
    var currentProductId = this.dataset.productId;
    if (currentProductId) {
      var ownSlide = this.placeholder.querySelector('.ia-size-upsell-slide[data-product-id="' + currentProductId + '"]');
      if (ownSlide) ownSlide.remove();
    }

    var slideCount = this.placeholder.querySelectorAll('.ia-size-upsell-slide').length;
    iaSizeUpsellLog('renderSectionHtml: slides after exclusion=', slideCount);
    if (slideCount === 0) {
      iaSizeUpsellLog('renderSectionHtml: no slides, hide');
      this.placeholder.innerHTML = '';
      this.hidden = true;
      return;
    }

    this.filterSlidesBySize();
    this._attachSlideTracking();
    this.destroySwiper();
    this.initSwiper();
    iaSizeUpsellLog('renderSectionHtml: injected, swiper inited');

    var titleEl = this.querySelector('.ia-size-upsell__title');
    if (titleEl) titleEl.removeAttribute('hidden');
    var ctaBlock = this.querySelector('.ia-size-upsell__cta');
    if (ctaBlock) {
      ctaBlock.removeAttribute('hidden');
      var ctaLink = ctaBlock.querySelector('.ia-size-upsell__cta-link');
      if (ctaLink) {
        ctaLink.href = this.buildCtaUrl();
        if (this._ctaClickHandler) ctaLink.removeEventListener('click', this._ctaClickHandler);
        var self = this;
        var parentTitle = this.dataset.productTitle || null;
        this._ctaClickHandler = function() {
          var payload = {
            event: 'ia_size_upsell_cta_clicked',
            parent_product_title: parentTitle,
            size: self.getSelectedSize() || null,
          };
          window.dataLayer?.push(payload);
          console.log('[ia-tracking] ia_size_upsell_cta_clicked', payload);
        };
        ctaLink.addEventListener('click', this._ctaClickHandler);
      }
    }
  }

  _attachSlideTracking() {
    var selectedSize = this.getSelectedSize();
    var parentProductTitle = this.dataset.productTitle || null;
    this.placeholder.querySelectorAll('.ia-size-upsell-slide:not(.ia-size-upsell-slide--hidden) a').forEach(function(link) {
      link.addEventListener('click', function() {
        var slide = link.closest('.ia-size-upsell-slide');
        var payload = {
          event: 'ia_size_upsell_product_clicked',
          parent_product_title: parentProductTitle,
          clicked_product_title: slide ? slide.dataset.productTitle || null : null,
          size: selectedSize || null,
        };
        window.dataLayer?.push(payload);
        console.log('[ia-tracking] ia_size_upsell_product_clicked', payload);
      });
    });
  }

  filterSlidesBySize() {
    var selectedSize = this.getSelectedSize();
    if (!selectedSize) {
      iaSizeUpsellLog('filterSlidesBySize: no selected size, showing all');
      return;
    }
    var slides = this.placeholder.querySelectorAll('.ia-size-upsell-slide');
    var visibleCount = 0;
    for (var i = 0; i < slides.length; i++) {
      var raw = slides[i].getAttribute('data-available-sizes') || '';
      var sizes = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (sizes.indexOf(selectedSize) === -1) {
        slides[i].classList.add('ia-size-upsell-slide--hidden');
      } else {
        slides[i].classList.remove('ia-size-upsell-slide--hidden');
        visibleCount++;
      }
    }
    iaSizeUpsellLog('filterSlidesBySize: selectedSize=', selectedSize, 'visible=', visibleCount, 'total=', slides.length);
    if (visibleCount === 0) {
      this.hidden = true;
      this.placeholder.innerHTML = '';
    }
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  initSwiper() {
    var slider = this.placeholder.querySelector('.ia-size-upsell-slider');
    if (!slider) {
      iaSizeUpsellLog('initSwiper: no .ia-size-upsell-slider in placeholder');
      return;
    }
    if (typeof Swiper === 'undefined') {
      iaSizeUpsellLog('initSwiper: Swiper not defined');
      return;
    }
    iaSizeUpsellLog('initSwiper: ok');

    var desktop = slider.dataset.slidesCountDesktop || '4.5';
    var mobile = slider.dataset.slidesCountMobile || '2';

    this.swiperInstance = new Swiper(slider, {
      direction: 'horizontal',
      spaceBetween: 15,
      slidesPerView: mobile,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      keyboard: { enabled: true },
      breakpoints: {
        989: { slidesPerView: desktop },
      },
    });
  }
}

customElements.define('ia-size-upsell', IaSizeUpsell);
